import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles({
  root: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    top: 0,
    left: 0,
    display: (props) => (props.isLoading ? "flex" : "none"),
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
    backgroundColor: "rgba(255, 255, 255 ,0.4)",
  },
});

// Block loading for specific loading states that want to block the entire screen.
function Loading() {
  const medicine = useSelector((state) => state.medicine.processing);
  const supply = useSelector((state) => state.supply.processing);
  const newMember = useSelector((state) => state.newMember.processing);
  const payment_detail = useSelector(
    (state) => state.payment.detail.processing
  );
  const order_address_book = useSelector(
    (state) => state.create_order.fetching
  );
  const order = useSelector((state) => state.create_order.processing);

  const bundle_list_loading = useSelector(
    (state) => state.bundle_list.fetching
  );

  const classes = useStyles({
    isLoading:
      medicine ||
      supply ||
      newMember ||
      payment_detail ||
      order_address_book ||
      order ||
      bundle_list_loading,
  });

  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
}

Loading.propTypes = {
  isLoading: PropTypes.bool,
};

export default Loading;
